import { SET_GA_LIST_INFO_VIEW } from "../../actions/dashboard/gaList"

const initialState = {
    gaList: null
}

const GAListReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GA_LIST_INFO_VIEW:
            return {
                ...state,
                gaList: action.payload
            }
        default:
            return state
    }
}
export default GAListReducer